import React from 'react';

import styles from './PerksDescriptionModal.module.scss';

import { Modal } from 'components/Modal';
import { ModalHeader } from 'components/ModalHeader/ModalHeader';
import { useCloseNavigate } from 'hooks/useCloseNavigate/useCloseNavigate';
import { RouteFC } from 'util/routeTypes';
import { PERKS_DESCRIPTION_MODAL } from './PerksDescriptionModal.const';
import { usePerks } from 'hooks/context/Perks';
import { useMerchantState } from 'hooks/context/MerchantState';
import { Icon } from 'components/Icon';
import { useSmartNavigate } from 'hooks/useSmartNavigate';
import { PerkDescriptionModalBody } from './PerksDescriptionModalBody';

type PerksDescriptionModalProps = {
  path?: string;
  uuid?:string;
}

export const PerksDescriptionModal: RouteFC<PerksDescriptionModalProps> = ({ path, uuid }) => {
  const navigate = useSmartNavigate();
  const { availablePerks, inProgressPerks, isLoading, getPerk } = usePerks();
  const { showPerksState } = useMerchantState();
  const onClose = useCloseNavigate(path);
  const perkItem = getPerk(uuid);
  const perkAvailable = availablePerks.length >0 || inProgressPerks.length>0;
  if (!showPerksState || (!isLoading && !perkAvailable) || !perkItem) return null;

  return (
    <Modal contentLabel={PERKS_DESCRIPTION_MODAL.root} isOpen className={styles.modal} onClose={onClose}>
      <ModalHeader
        onClose={onClose}
        data-testid={PERKS_DESCRIPTION_MODAL.title}
        id={PERKS_DESCRIPTION_MODAL.id}
        className={styles.descritionModalHeader}
      >
      <button className={styles.backButton}>
        <Icon className={styles.backArrow} data-testid={PERKS_DESCRIPTION_MODAL.iconName} name="backArrow" size={24} onClick={() => navigate('~perks')}></Icon>
      </button>
      </ModalHeader>
      {perkAvailable && <PerkDescriptionModalBody selectedPerk={perkItem} />}
    </Modal>
  );
};
